module.exports = __webpack_public_path__ + "static/media/sexy-sm-off.865f431a.png";